import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const DEPRECIATION_TAGS: any = [
  'assetHistory',
  'disposal',
  'Asset',
  'depreciationRun',
  'depreciationStatus',
  'periods',
  'productionUnits',
]

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URI,
  prepareHeaders: headers => {
    const token = JSON.parse(
      sessionStorage.getItem(
        `oidc.user:${process.env.REACT_APP_AUTHORITY}:${process.env.REACT_APP_CLIENT_ID}`
      )
    )?.access_token

    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    } else {
      alert('Please login again.')
    }

    return headers
  },
})

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: [
    'Asset',
    'assetCharge',
    'assetDepreciation',
    'assetHistory',
    'assetLocation',
    'assetStructures',
    'assetTags',
    'attachment',
    'comment',
    'company',
    'customDepreciation',
    'dashboard',
    'depreciation',
    'depreciationRun',
    'depreciationStatus',
    'disposal',
    'fieldParms',
    'folder',
    'glPost',
    'identifiers',
    'insurance',
    'maintenance',
    'periods',
    'productionUnits',
    'reportTemplate',
    'segment',
    'setting',
    'task',
    'userTableParams',
    'vendor',
    'years',
  ],
  endpoints: () => ({}),
})
